import React from "react";
import { authPaymentTypes } from "../../../parent/data/auth-payment-types";
import Show from "../../../../../utils/show.component";

export const PayoffLetterPopupButton = ({ OtherAuthLoanOptions, selectPaymentType, lastFour }) => {
  const shouldShowGeneratePayoffLetter = () => {
    const show = OtherAuthLoanOptions.Has10DayPayoffLetterPermissions ? true : false;

    return show;
  };

  return (
    <Show condition={shouldShowGeneratePayoffLetter()}>
      <li>
        <button
          className="f12 mt-0 auth-card-popup-button"
          onClick={() => {
            selectPaymentType(authPaymentTypes.other.PayoffLetter, false);
          }}
          data-e2e-id={"payoffLetterButton-" + lastFour}
        >
          Generate Payoff Letter
        </button>
      </li>
    </Show>
  );
};



// WEBPACK FOOTER //
// ./src/components/authenticated-payments/loan-list/card-children/popup-menu-buttons/payoff-letter-popup-button.component.js